import styled from "@emotion/styled";

export const MainTitleContainer = styled.div`
  margin-bottom: 25px;
`

export const TitleContainer = styled.div`
  margin-bottom: 10px;
`

export const BoldText = styled.span`
  font-weight: bold;
`

export const Margin50 = styled.div`
  height: 50px;
`

export const Margin25 = styled.div`
  height: 50px;
`
